export default "__VITE_ASSET__BM17xxAv__"